export default class AdditionalCharge {

    id: string;
    code: string;
    name: string;
    value: number;
    description: string;
    isAutoApply: boolean;
    appliedInCart: boolean;
    type: string;
    totalDiscount: number;

    constructor(mainItem: any = {}, additionalCharge: any = {}, appliedInCart: boolean, isManualAppliedAccessory: boolean = false) {

        let chargeValue = additionalCharge.value;
        if (!appliedInCart && additionalCharge.type === 'perUnitExtraCharges' && additionalCharge.applicableChargeRules?.accessories?.length > 0 && additionalCharge.applicableChargeRules?.accessories[0]?.unitPriceWithCharge){
            chargeValue = additionalCharge.applicableChargeRules.accessories[0].unitPriceWithCharge;
        }
        const mainItemId = mainItem?.data ? mainItem.data.id : mainItem.id;
        const effectivePrice = mainItem?.data ? mainItem.data.effectivePrice : mainItem.effectivePrice;

        this.code = additionalCharge.code ?? '';
        this.id = `${this.code.replace(/\s+/g,'')}-${mainItemId}` ?? '';
        const nameValue = additionalCharge?.name;
        this.name = typeof nameValue === 'string' ? nameValue.trim() : '';
        this.value = appliedInCart ? isManualAppliedAccessory ? additionalCharge.totalValue : effectivePrice?.originalPrice.additionalItemDetails[additionalCharge.code] ?? 0 : chargeValue;
        this.description = additionalCharge.description ?? '';
        this.isAutoApply = additionalCharge.isAutoApply ?? false;
        this.appliedInCart = appliedInCart;
        this.type = additionalCharge.type ?? '';
        this.totalDiscount = Number(effectivePrice?.discount?.additionalChargesTotalIncludingAccessory ?? 0);

    }
}
